import {createAction, createActionGroup, emptyProps, props} from "@ngrx/store";
import { Auth } from "../../auth/primitives/auth";
import {User} from "../../auth/primitives/user";

export const authActions = createActionGroup({
  source: "Auth",
  events: {
    "Login Started": props<{
      username: string;
      password: string;
      returnUrl: string;
    }>(),
    "Login Succeeded": props<{ auth: Auth; returnUrl: string }>(),
    "Login Failed": props<{ error: any }>(),
    "Signup Started": props<{
      email: string;
      username: string;
      password: string;
      returnUrl: string;
    }>(),
    "Signup Succeeded": props<{ auth: Auth; returnUrl: string }>(),
    "Signup Failed": props<{ error: any }>(),
    "Fetch User": emptyProps(),
    "Fetch User Started": emptyProps(),
    "Fetch User Failed": props<{ error: any }>(),
    "Fetch User Succeeded": props<{ user: User }>(),
    "Auth ready": props<{ user: User, isGuest: boolean}>(),
    "Me Updated": props<{ user: User }>(),
    "Logout User": emptyProps(),
    "Attempt Unauthenticated Navigation": props<{ route: string }>(),
  },
});

export const appStarted = createAction("[Application] Started");
